export default __webpack_public_path__ + "locales/fi/Common.json?hash=67c0cb96d8f3c626c059bb39016be79c";